import BackgroundImage from "gatsby-background-image"
import styled, { FlattenSimpleInterpolation } from "styled-components"
import Breakpoints from "./breakpoints"
import {
  desktopTextStyles,
  mobileTextStyles,
  tabletTextStyles,
} from "./typography.styles"

export const Title = styled.h1`
  margin-top: 130px;
  grid-column: 1 / -1;
  ${mobileTextStyles.MobileHeadingOneBold}

  color: var(--title-grey);

  &:last-child {
    margin-bottom: 140px;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    margin-top: 159px;
    ${tabletTextStyles.TabletHeadingOneRegular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingOneRegular}
    grid-column: 3 / -3;
    margin-top: 184px;
  }
`

export const Description = styled.p<{
  styleModifier: FlattenSimpleInterpolation
}>`
  grid-column: 1 / -1;
  ${mobileTextStyles.MobileBodyRegular}

  color: var(--dark-mode-body-grey);
  margin-top: 32px;
  margin-bottom: 120px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -3;
    ${desktopTextStyles.BodyText18}
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -5;
  }

  ${(props) => props.styleModifier}
`

export const HeroContainer = styled(BackgroundImage)``
